import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, search, nullsafe, assertUnreachable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx, } from "app/logic/rx";
import { observeResource, invalidateResource } from "kea-resource";
import * as globals from "app/resources/globals";
import { DestinosList } from "./listmem";
import * as rx from "rxjs";
import { IniciarViajeZEEdit, IniciarViajeZEModel } from "./iniciar";

export interface Props {
    value: models.ViajeZEAppIniciado | null;
}

const IniciarButton = kea.defaultProps(kea.Button, { children: "Iniciar viaje", iconClass: fa("check"), style: "success" });
const CancelarButton = kea.defaultProps(kea.Button, { children: "Cancelar viaje", style: "danger", iconClass: fa("times") });
const RecargarButton = kea.defaultProps(kea.Button, { children: "Refrescar viaje", style: "success", iconClass: fa("circle-o-notch") });

class ListaDestinosNoRx extends React.PureComponent<Props> {
    modalManager = kea.createModalManager();

    viaje = (props: Props) => props.value;
    items = createSelectorRx(this.viaje, viaje => viaje ? viaje.Destinos : []);

    onCancelarViaje = async () => {
        if (await kea.yesno("¿Cancelar el viaje?")) {
            await resources.ViajeZEApp.CancelarViajeZEApp(this.props.value!.IdViajeZE);
            await kea.message("Viaje cancelado");
        }
    }

    onRefresh = async () => {
        await invalidateResource(resources.ViajeZEApp);
    }

    onIniciarViaje = async () => {
        const response = await this.modalManager.showModal(IniciarViajeZEEdit, undefined, {} as IniciarViajeZEModel);
        if (response.result) {
            const value = response.value;
            await resources.ViajeZEApp.IniciarViajeZEApp(value.idViajeZE);
            await kea.message("Viaje iniciado", "", "success");
        }
    }

    render() {
        const noHayDatos =
            <div className="alert alert-warning">
                <label>No tiene viaje de zona extendida iniciado</label>
                <br />
                <div className="btn-group">
                    <IniciarButton onClick={this.onIniciarViaje} />
                </div>
            </div>;


        return (
            <div>
                {
                    (this.props.value != null) ?
                        (
                            this.props.value.ViajeTieneSalida ?
                                <DestinosList
                                    items={this.items(this.props)}
                                    idViajeZE={this.props.value.IdViajeZE}
                                    value={this.props.value}
                                /> :
                                <div className="alert alert-warning">
                                    <h3>Viaje iniciado, falta dar salida</h3>
                                    <br />
                                    Folio de viaje: {this.props.value.FolioViaje}
                                    <hr />
                                    <br />
                                    Indique al operador <b>dar salida</b> a su viaje
                                    <hr />
                                    <div className="btn-group">
                                        <CancelarButton onClick={this.onCancelarViaje} />
                                        <RecargarButton onClick={this.onRefresh} />
                                    </div>
                                </div>

                        ) :
                        noHayDatos
                }
                {this.modalManager.component}
            </div>
        )
    }
}

const ListaDestinosRx = componentToRx(ListaDestinosNoRx);

export class ListaDestinos extends React.PureComponent {

    idViajeZE = () => observeResource(resources.ViajeZEApp.ObtenerIdViajeZEUsuario);

    value = createSelectorRx(this.idViajeZE, (idViajeZE) => idViajeZE ?
        observeResource(resources.ViajeZEApp.ObtenerDestinosViajeZEApp, idViajeZE)
        : rx.Observable.from([null]));

    render() {
        const value = this.value(this);
        return <div>
            <ListaDestinosRx value={value} />
        </div>
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeappZE/destinos/list.tsx